import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import { FormRow, FormRowView } from "components/shared";
import { UITextInput } from "components/ui";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayCreateTemplateFileExcludeWidget
 * @return {React.Component}
 * @exported true
 * @description 
 */
export default function TASPositivePayCreateTemplateFileExcludeWidget(prop) {
    const {data, onChangeCheckTemp } = useStateManager();
    const checkTemplate = data.checkTemplate;

    return (
        <div className="tas-positive-pay-create-template-file-exclude-widget">
            <h2>Number of Rows to Exclude</h2>
            <FormRow className="header-footer-row flex-horizontal align-center">
                <FormRowView className="header-row" text={
                    <div className="flex-container flex-horizontal align-center">
                        <p className="label-with-icon">Header (Optional)</p>
                        <SVGAsset id="InfoIcon" />
                    </div>
                }>
                    <UITextInput dataPoint={ `Number_Of_Header_Rows_Input` } 
                    value={ checkTemplate.numberOfRowsToExcludeHeader } onChange={ onChangeCheckTemp("numberOfRowsToExcludeHeader") } />
                </FormRowView>
                <FormRowView className="footer-row" text={
                    <div className="flex-container flex-horizontal align-center">
                        <p className="label-with-icon">Footer (Optional)</p>
                        <SVGAsset id="InfoIcon" />
                    </div>
                }>
                    <UITextInput dataPoint={ `Number_Of_Footer_Rows_Input` } 
                    value={ checkTemplate.numberOfRowsToExcludeFooter } onChange={ onChangeCheckTemp("numberOfRowsToExcludeFooter") }/>
                </FormRowView>
            </FormRow>
            <FormRowView className="text-qualifier-row" text={
                <div className="flex-container flex-horizontal align-center">
                    <p className="label-with-icon">Text Qualifier</p>
                    <SVGAsset id="InfoIcon" />
                </div>
            }>
                <DisabledPrompt>
                    <CustomSelect value={ checkTemplate.textQualified } onChange={ onChangeCheckTemp("textQualified") }>
                        <CustomSelectItem dataPoint={ `Text_Qualifier_Select_Option_None` } value="none">None</CustomSelectItem>
                    </CustomSelect>
                </DisabledPrompt>
            </FormRowView>
        </div>
    )
}
